// @flow
// @flow-runtime warn
import { createContext } from 'react';

import type { StatementsType, StatementSubmitType } from './StatementsTypes';
import { defaultStatementsState } from './useStatementsData';


type StatementsContextType = [
  [StatementsType, boolean, boolean], {
    handleRequestStatements: () => Promise<boolean> | boolean,
    handleRequestNextStatements: () => Promise<boolean> | boolean,
    handleSubmitStatement: (submitData: StatementSubmitType) => Promise<boolean> | boolean,
  }
]

const defaultContext: StatementsContextType = [
  [defaultStatementsState, true, false], {
    handleRequestStatements: () => false,
    handleRequestNextStatements: () => false,
    handleSubmitStatement: () => false,
  },
];

export default createContext<StatementsContextType>(defaultContext);
